import React from 'react';
import { Outlet, Link, useNavigate } from 'react-router-dom';
import { AppBar, Toolbar, Typography, Box, Button } from '@mui/material';

export const SuperAdminLayout: React.FC = () => {
  const navigate = useNavigate();
  const logout = () => {
    localStorage.removeItem('sa_token');
    navigate('/super-admin/login');
  };
  return (
    <Box sx={{ minHeight: '100vh', bgcolor: 'background.default' }}>
      <AppBar position="static" color="default" elevation={0}>
        <Toolbar>
          <Typography variant="h6" sx={{ flexGrow: 1 }}>
            Super Admin • DashFlow
          </Typography>
          <Button color="inherit" component={Link} to="/super-admin/dashboard">Dashboard</Button>
          <Button color="inherit" component={Link} to="/super-admin/tenants">Tenants</Button>
          <Button color="inherit" component={Link} to="/super-admin/payments">Payments</Button>
          <Button color="inherit" component={Link} to="/super-admin/emails">Emails</Button>
          <Button color="inherit" onClick={logout}>Salir</Button>
        </Toolbar>
      </AppBar>
      <Box sx={{ p: 3 }}>
        <Outlet />
      </Box>
    </Box>
  );
};
